import JwtService from '../../../common/jwt.service';
import ApiService from '../../../common/api.service';
import mutations from './mutations';

const state = () => ({
    loading: false,
    error: null,
    work: null,
    workteam: null,
    workUserRole: null,
});

const actions = {
    async getActiveWork({ commit }, workId) {
        try {
            commit('activeWorkBegin');
            ApiService.get(`work/getInitialWorkData/${workId}`).then((response) => {
                if (response.data.status == 'success') {
                    commit('activeWorkSuccess', response.data);
                } else {
                    commit('activeWorkErr', err);
                }
            });
        } catch (err) {
            commit('activeWorkErr', err);
        }
    },
    resetActiveWork({ commit }) {
        commit('activeWorkReset');
    },
};

// const getters = {
//     work: (state) => state.work,
// };

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    // getters,
};
